module.exports = __webpack_public_path__ + "img/11.78728ea2.jpg";